import {
  compose,
  css,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from '@wrisk/styled-system'
import styled from 'styled-components'

import { withDefaultProps } from '../../defaultProps'

export type LogoNavProperty = 'default'

export interface LogoNavProps extends LayoutProps, SpaceProps {
  variant?: LogoNavProperty
}

const defaultProps = withDefaultProps<LogoNavProps>({
  variant: 'default',
})

export const LogoNav = styled.div.attrs<LogoNavProps>(defaultProps)(
  css({
    display: 'flex',
    alignItems: 'center',
    minHeight: '50%',
    lineHeight: 0,
  }),
  variant({
    scale: 'LogoNav',
    variants: {
      default: {},
    },
  }),
  compose(layout, space),
)
